export default {
  en: {
    unanswered: 'Unanswered',
    notApplicable: 'Not applicable',
    invalid: 'Invalid',
    unknown: 'Unknown',
    selectionCount: '{n} selected',
    notRequired: 'Not required',
    policyRequirement: '{n} selected in allow list',
    requireOnly: 'Require only',
    requireHeading: 'Countries',
    policyPlaceholder: 'Search for countries to add',
    outOfScope: 'Out of scope',
    lastModified: 'Last modified {0}',
    selectPlaceholder: 'Search for countries to add',
    emptyTitle: 'No countries selected',
    emptySubTitle: 'Use the dropdown to add some',
    addNotes: 'Add notes...',
    errors: {
      emptyMultiselect: 'Requires at least one field to be selected.',
    },
  },
};
